import { Search, Save, FileSearch, Mail, Plus, Activity } from "lucide-react";

export const ACTION_META = {
  search: { label: "Search", icon: Search, color: "#3B82F6" },
  save: { label: "Save to CRM", icon: Save, color: "#22C55E" },
  audit: { label: "Run Audit", icon: FileSearch, color: "#F59E0B" },
  email: { label: "Generate Email", icon: Mail, color: "#8B5CF6" },
  manual_add: { label: "Manual Add", icon: Plus, color: "#EC4899" },
};

export const FALLBACK_ACTION_META = {
  label: "Action",
  icon: Activity,
  color: "#6B7280",
};

export const getActionMeta = (action) => ACTION_META[action] || { ...FALLBACK_ACTION_META, label: action };
